export default __webpack_public_path__ + "static/media/down_arrow.0e708c15.svg";